import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { ToastrService } from '@shared/services/toastr.service';
import { PageView } from '@shared/enums/enums';
import { AuthService } from '@shared/services/auth.service';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-cluster-type',
  templateUrl: './cluster-type.component.html',
  styleUrls: ['./cluster-type.component.scss'],
  imports: [NgIf, NgFor, FormsModule, TranslatePipe],
})
export class ClusterTypeComponent implements OnInit {
  lang: string;

  showView: PageView = PageView.LIST;
  pageViews = PageView;
  user: any = {};
  clusterTypes: any = [];
  clusterType: any = {};
  @ViewChild('modal') modal: any;

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private auth: AuthService,
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.user = this.auth.user;
    this.getTypeCluster();
  }

  getTypeCluster() {
    this.http
      .post('clusterType/get', {
        data: {},
      })
      .subscribe((res: any) => {
        if (!res.hasError) {
          this.clusterTypes = res.items;
        }
      });
  }

  editClusterType(p: any) {
    this.showView = PageView.EDIT;
    this.clusterType = p;
  }

  updateClusterType(p) {
    this.http
      .post('clusterType/update', {
        datas: [{ ...p }],
      })
      .subscribe((res: any) => {
        if (!res.hasError) {
          this.toastr.success('MiseAJourReussie');
          this.reset();
        } else {
          this.toastr.error('EnregistrementEchoue');
        }
      });
  }

  createTemplate() {
    this.showView = PageView.CREATE;
  }

  createClusterType(p) {
    this.http
      .post('clusterType/create', {
        datas: [{ ...p }],
      })
      .subscribe((res: any) => {
        if (!res.hasError) {
          this.toastr.success('EnregistrementReussi');
          this.reset();
        } else {
          this.toastr.error('EnregistrementEchoue');
        }
      });
  }

  reset() {
    this.getTypeCluster();
    this.showView = PageView.LIST;
    this.clusterType = {};
  }
}
